import React from "react";

import { useDevice, useDrawer, useTheme } from "../../../common/hooks";
import { Drawer } from "@mantine/core";
import Wip from "../Wip";
import "./drawer.css";

const SIZES = {
  right: { mobile: "85%", desktop: "30%" },
  bottom: { mobile: "80%", desktop: "40%" },
};

export default function ContentDrawer() {
  const { isOpen, props, content, closeDrawer } = useDrawer();
  const { theme } = useTheme();
  const { device } = useDevice();

  const position = props?.position ?? "right";

  const style = {
    background: theme.primaryBackground,
  };

  const onClose = () => {
    closeDrawer();
  };

  return (
    <Drawer
      opened={isOpen}
      onClose={onClose}
      padding="0"
      size={SIZES[position][device]}
      position={position}
      overlayOpacity={0}
      hideCloseButton
      noFocusTrap
      transitionDuration={300}
      withCloseButton={false}
      className="drawer"
    >
      <div className="drawer-content" style={style}>
        {content || <Wip />}
      </div>
    </Drawer>
  );
}
